module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Color ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBoxSize'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Box Size\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicCursor'
      }
    }
  }, [_vm._v("\n            Cursor   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-color"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Color\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_cl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("color")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_cl-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Biomatic's Color Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("primary[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("accent[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("neutral[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("positive")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("negative")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("warning")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("gray")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("dark")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("black")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-hover")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Main Color -->\n<p class=\"_cl-primary\">Hello World</p>\n<p class=\"_cl-accent\">Hello World</p>\n<p class=\"_cl-neutral\">Hello World</p>\n\n<!-- Semantic Color -->\n<p class=\"_cl-positive\">Hello World</p>\n<p class=\"_cl-negative\">Hello World</p>\n<p class=\"_cl-warning\">Hello World</p>\n<p class=\"_cl-info\">Hello World</p>\n\n<!-- Gray Scale Color -->\n<p class=\"_cl-white\">Hello World</p>\n<p class=\"_cl-gray\">Hello World</p>\n<p class=\"_cl-dark\">Hello World</p>\n<p class=\"_cl-black\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-primary"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-positive"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-negative"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-warning"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-info"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-white"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-gray"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-dark"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-black"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Main Color – Primary พร้อม Weight Modifier")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Primary Color -->\n<p class=\"_cl-primary-100\">Hello World</p>\n<p class=\"_cl-primary-200\">Hello World</p>\n<p class=\"_cl-primary-300\">Hello World</p>\n<p class=\"_cl-primary-400\">Hello World</p>\n<p class=\"_cl-primary-500\">Hello World</p>\n<p class=\"_cl-primary-600\">Hello World</p>\n<p class=\"_cl-primary-700\">Hello World</p>\n<p class=\"_cl-primary-800\">Hello World</p>\n<p class=\"_cl-primary-900\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-primary-100"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-200"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-300"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-400"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-500"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-600"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-700"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-800"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-900"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Main Color – Accent พร้อม Weight Modifier")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Accent Color -->\n<p class=\"_cl-accent-100\">Hello World</p>\n<p class=\"_cl-accent-200\">Hello World</p>\n<p class=\"_cl-accent-300\">Hello World</p>\n<p class=\"_cl-accent-400\">Hello World</p>\n<p class=\"_cl-accent-500\">Hello World</p>\n<p class=\"_cl-accent-600\">Hello World</p>\n<p class=\"_cl-accent-700\">Hello World</p>\n<p class=\"_cl-accent-800\">Hello World</p>\n<p class=\"_cl-accent-900\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-accent-100"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-200"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-300"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-400"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-500"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-600"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-700"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-800"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-900"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Main Color – Neutral พร้อม Weight Modifier")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Neutral Color -->\n<p class=\"_cl-neutral-100\">Hello World</p>\n<p class=\"_cl-neutral-200\">Hello World</p>\n<p class=\"_cl-neutral-300\">Hello World</p>\n<p class=\"_cl-neutral-400\">Hello World</p>\n<p class=\"_cl-neutral-500\">Hello World</p>\n<p class=\"_cl-neutral-600\">Hello World</p>\n<p class=\"_cl-neutral-700\">Hello World</p>\n<p class=\"_cl-neutral-800\">Hello World</p>\n<p class=\"_cl-neutral-900\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-neutral-100"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-200"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-300"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-400"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-500"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-600"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-700"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-800"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-900"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Color – Hover")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<p class=\"_cl-positive _cl-negative-hover\">\n  Hover Me\n</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-positive _cl-negative-hover _dp-ilb"
  }, [_vm._v("Hover Me")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f10a58c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicColor.vue
// module id = 119
// module chunks = 0